export default "__VITE_ASSET__j2QxStn6__"